import legusta01 from "@/assets/units/legusta-n-IMG_0370.jpg.asset.json";
import legusta02 from "@/assets/units/legusta-n-IMG_0377.jpg.asset.json";
import legusta03 from "@/assets/units/legusta-n-IMG_0373.jpg.asset.json";
import legusta04 from "@/assets/units/legusta-n-IMG_0364.jpg.asset.json";
import legusta05 from "@/assets/units/legusta-n-IMG_0369.jpg.asset.json";
import legusta06 from "@/assets/units/legusta-n-IMG_0361.jpg.asset.json";

import barra01 from "@/assets/units/barra-n-6.jpg.asset.json";
import barra02 from "@/assets/units/barra-n-1.jpg.asset.json";
import barra03 from "@/assets/units/barra-n-2.jpg.asset.json";
import barra04 from "@/assets/units/barra-n-7.jpg.asset.json";
import barra05 from "@/assets/units/barra-n-IMG_3482.jpg.asset.json";
import barra06 from "@/assets/units/barra-n-4.jpg.asset.json";
import barra07 from "@/assets/units/barra-n-5.jpg.asset.json";

import americas01 from "@/assets/units/americas-n3-0170.jpg.asset.json";
import americas02 from "@/assets/units/americas-n3-0171.jpg.asset.json";
import americas03 from "@/assets/units/americas-n3-0174.jpg.asset.json";
import americas04 from "@/assets/units/americas-n3-0175.jpg.asset.json";
import americas05 from "@/assets/units/americas-n3-0176.jpg.asset.json";
import americas06 from "@/assets/units/americas-n3-0177.jpg.asset.json";
import americas07 from "@/assets/units/americas-n3-0179.jpg.asset.json";
import americas08 from "@/assets/units/americas-n3-0181.jpg.asset.json";
import americas09 from "@/assets/units/americas-n3-0183.jpg.asset.json";

/**
 * Fonte única de verdade das unidades Nook.
 * Dados herdados da landing page (lp.nookgym.com.br).
 *
 * REVISAR ANTES DE PUBLICAR (marcados com `pending: true`):
 * horários, telefone fixo, coordenadas, Google Place ID, Instagram por unidade
 * e o endereço completo da unidade Américas — validar no Perfil da Empresa no Google.
 */

export type UnitSlug = "recreio-le-gusta" | "barra-da-tijuca" | "recreio-americas";

export type Unit = {
  slug: UnitSlug;
  /** valor enviado para a LP em ?unit= */
  lpParam: "recreio-le-gusta" | "barra" | "americas";
  code: string;
  name: string;
  shortName: string;
  neighborhood: string;
  street: string;
  city: string;
  state: string;
  addressLine: string;
  contextLine: string;
  phone: string | null;
  whatsapp: string;
  whatsappMessage: string;
  hours: { label: string; value: string }[] | null;
  coordinates: { lat: number; lng: number } | null;
  placeIdEnvKey: string;
  /** Google Place ID (formato ChIJ…) — identificador público, pode ficar no código */
  placeId?: string;
  /** Google Maps CID (identificador numérico do perfil da empresa) */
  googleCid?: string;
  /** link direto para as avaliações do perfil no Google */
  reviewsUrl: string;
  /** fotos ainda não são da unidade (exibir com blur) */
  photosPending?: boolean;

  instagram: string;
  mapsUrl: string;
  wazeUrl: string;
  /** título do bloco final de CTA da página da unidade */
  ctaTitle?: string;
  directionsHint: string;
  landmarks: string[];
  parking: string | null;
  images: { src: string; alt: string }[];
  pending: string[];
};

const legustaImages = [legusta01, legusta02, legusta03, legusta04, legusta05, legusta06].map((a) => a.url);
const barraImages = [barra01, barra02, barra03, barra04, barra05, barra06, barra07].map((a) => a.url);
const americasImages = [
  americas09,
  americas01,
  americas02,
  americas03,
  americas04,
  americas05,
  americas06,
  americas07,
  americas08,
].map((a) => a.url);

export const UNITS: Unit[] = [
  {
    slug: "recreio-le-gusta",
    lpParam: "recreio-le-gusta",
    code: "N1",
    name: "Nook Recreio — Le Gusta",
    shortName: "Recreio — Le Gusta",
    neighborhood: "Recreio dos Bandeirantes",
    street: "Rua Professora Luiza Nogueira Gonçalves, 350",
    city: "Rio de Janeiro",
    state: "RJ",
    addressLine: "Rua Professora Luiza Nogueira Gonçalves, 350 — Recreio dos Bandeirantes — RJ",
    contextLine: "O lugar onde a Nook surgiu.\nAcompanhamento personalizado\nem ambiente reservado.",
    phone: "+5521977280325",
    whatsapp: "5521977280325",
    whatsappMessage: "Olá, gostaria de garantir meu Day Use na Nook Recreio",
    hours: [
      { label: "Seg a Sex", value: "6h às 22h" },
      { label: "Sábado", value: "8h às 14h" },
      { label: "Domingo", value: "Fechado" },
    ],
    coordinates: null,
    placeIdEnvKey: "GOOGLE_PLACE_ID_RECREIO_LE_GUSTA",
    placeId: "ChIJZb1byMXdmwAR8D3yfKVl5jo",
    googleCid: "01142372373891666595",
    instagram: "https://www.instagram.com/nookgym/",
    mapsUrl: "https://share.google/oGAp4Ecj3j57iRSlL",
    wazeUrl: "https://www.waze.com/en/live-map/directions/br/rj/nook-gym?place=ChIJZb1byMXdmwAR8D3yfKVl5jo",
    ctaTitle: "Venha conhecer Nook — Shopping Le Gusta.",
    reviewsUrl: "https://share.google/ptskxe5Puv41e4bID",

    directionsHint: "Rua interna do Recreio, próxima ao complexo Le Gusta.",
    landmarks: ["Complexo Le Gusta"],
    parking: null,
    images: legustaImages.map((src, i) => ({
      src,
      alt: `Ambiente da Nook Recreio — Le Gusta, foto ${i + 1}`,
    })),
    pending: ["horários", "telefone", "coordenadas", "estacionamento"],
  },
  {
    slug: "barra-da-tijuca",
    lpParam: "barra",
    code: "N2",
    name: "Nook Barra da Tijuca — Rosas",
    shortName: "Barra da Tijuca — Rosas",
    neighborhood: "Barra da Tijuca",
    street: "Av. Marechal Henrique Lott, 163",
    city: "Rio de Janeiro",
    state: "RJ",
    addressLine: "Av. Marechal Henrique Lott, 163 — Barra da Tijuca — RJ",
    contextLine: "Estrutura ampla e treino acompanhado\nno coração da Barra.",
    phone: "+5521992718334",
    whatsapp: "5521992718334",
    whatsappMessage: "Olá, gostaria de garantir meu Day Use na Nook Barra",
    hours: [
      { label: "Seg a Sex", value: "6h às 22h" },
      { label: "Sábado", value: "8h às 14h" },
      { label: "Domingo", value: "Fechado" },
    ],
    coordinates: null,
    placeIdEnvKey: "GOOGLE_PLACE_ID_BARRA",
    placeId: "ChIJrdCMmpLbmwARVps6AmD_h3s",
    instagram: "https://www.instagram.com/nookgymbarra/",
    reviewsUrl: "https://share.google/XKKGFE3sCrEEw2gp3",
    mapsUrl: "https://share.google/nnNwGTkdONWcqKGNB",
    wazeUrl: "https://www.waze.com/en/live-map/directions/br/rj/nook-gym-barra?place=ChIJrdCMmpLbmwARVps6AmD_h3s",
    ctaTitle: "Venha conhecer Nook — Barra da Tijuca.",
    directionsHint: "Região da Península, acesso pela Av. Marechal Henrique Lott.",
    landmarks: ["Península"],
    parking: null,
    images: barraImages.map((src, i) => ({
      src,
      alt: `Ambiente da Nook Barra da Tijuca, foto ${i + 1}`,
    })),
    pending: ["horários", "telefone", "coordenadas", "estacionamento"],
  },
  {
    slug: "recreio-americas",
    lpParam: "americas",
    code: "N3",
    name: "Nook Recreio — Américas",
    shortName: "Recreio — Américas",
    neighborhood: "Recreio dos Bandeirantes",
    street: "Av. das Américas, 15455",
    city: "Rio de Janeiro",
    state: "RJ",
    addressLine: "Av. das Américas, 15455 — Recreio dos Bandeirantes — RJ",
    contextLine: "A unidade mais nova da Nook,\nna Avenida das Américas.",
    phone: "+5521990446827",
    whatsapp: "5521990446827",
    whatsappMessage: "Olá, quero treinar na Nook Américas, como faço para ser um Nooker?",
    hours: [
      { label: "Seg a Sex", value: "6h às 22h" },
      { label: "Sábado", value: "8h às 14h" },
      { label: "Domingo", value: "Fechado" },
    ],
    coordinates: null,
    placeIdEnvKey: "GOOGLE_PLACE_ID_AMERICAS",
    instagram: "https://www.instagram.com/nookgymamericas/",
    mapsUrl: "https://share.google/GBzoUvvfRXs1Fn3Kb",
    wazeUrl: "https://www.waze.com/en/live-map/directions/br/rj/nook-gym-americas?place=ChIJQxHKdz3dmwARFlubUL3CIgc",
    ctaTitle: "Venha conhecer Nook — Américas.",
    reviewsUrl: "https://share.google/XnkupQaLMQmgnAclq",
    directionsHint: "Sobre a Av. das Américas, sentido Recreio.",
    landmarks: [],
    parking: null,
    images: americasImages.map((src, i) => ({
      src,
      alt: `Ambiente da Nook Recreio — Américas, foto ${i + 1}`,
    })),
    pending: [
      "endereço completo (validar no Perfil da Empresa no Google)",
      "horários",
      "telefone",
      "coordenadas",
      "Google Place ID",
      "Instagram da unidade",
    ],
  },
];

export const UNITS_BY_SLUG = Object.fromEntries(UNITS.map((u) => [u.slug, u])) as Record<UnitSlug, Unit>;

export function phoneDisplay(unit: Unit): string | null {
  if (!unit.whatsapp) return null;
  const d = unit.whatsapp.replace(/\D/g, "").replace(/^55/, "");
  if (d.length !== 11) return null;
  return `(${d.slice(0, 2)}) ${d.slice(2, 3)} ${d.slice(3, 7)}-${d.slice(7)}`;
}

export function getUnit(slug: string): Unit | undefined {
  return UNITS_BY_SLUG[slug as UnitSlug];
}

export const BRAND = {
  name: "Nook Gym",
  legalName: "Nook Gym",
  tagline: "Treinamento acompanhado de verdade",
  site: "https://nookgym.com.br",
  lp: "https://lp.nookgym.com.br",
  instagram: "https://www.instagram.com/nookgym/",
  sameAs: ["https://www.instagram.com/nookgym/"],
} as const;
